const KEY = "pathqity_theme";

export const getTheme = () => localStorage.getItem(KEY) || "light";

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("dark", theme === "dark");
  localStorage.setItem(KEY, theme);
};

export const initTheme = () => applyTheme(getTheme());
